import { subscribe } from '@wh/message-bus';

export const myAccountNativeDeepLinksFromMessagebusPlugin = {
  postBootstrap({ params }) {
    subscribe({
      topic: 'wh.myAccount.command.dropdown.open',
      callback: ({ data }) => {
        const standaloneUrl = data && params.mapping[data.path];
        if (!standaloneUrl) {
          return;
        }
        window.location.href = `whsbkh://?action=openURLWithLogin&url=${encodeURIComponent(standaloneUrl)}`;
      },
    });
  },
};
